import { AnimatePresence, motion } from "framer-motion";

export const QualQuestion = ({ meets, setMeets, qAccounts, setQAccounts, qLimits, setQLimits, missing, setMissing, errors }) => (
  <div style={{ marginBottom: 22 }} id="meets" tabIndex={-1}>
    <span className="qual-q">Do you feel you meet the criteria listed above?</span>
    <div className="radio-row" role="radiogroup" aria-invalid={!!errors.meets}>
      <label className="radio-opt">
        <input type="radio" name="meets_criteria" value="yes" checked={meets === "yes"}
          onChange={() => setMeets("yes")} data-testid="qual-yes-radio" /> Yes, I meet the criteria
      </label>
      <label className="radio-opt">
        <input type="radio" name="meets_criteria" value="no" checked={meets === "no"}
          onChange={() => setMeets("no")} data-testid="qual-no-radio" /> No, I am not sure
      </label>
    </div>
    {errors.meets && <div className="field-error" data-testid="error-meets">{errors.meets}</div>}
    <AnimatePresence initial={false}>
      {meets === "no" && (
        <motion.div className="qual-panel" data-testid="qual-no-panel"
          initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}>
          <div className="missing-field">
            <label className="field-label" htmlFor="missing">What are you missing from the criteria?</label>
            <textarea id="missing" rows={3} value={missing} onChange={(e) => setMissing(e.target.value)}
              className={`text-input text-area${errors.missing ? " invalid" : ""}`} data-testid="input-missing" />
            {errors.missing && <div className="field-error" data-testid="error-missing">{errors.missing}</div>}
          </div>
          <p className="qual-panel-head">Let us help you find out. Answer the following:</p>
          <div style={{ display: "grid", gap: 12 }}>
            <label className="check-opt">
              <input type="checkbox" checked={qAccounts} onChange={(e) => setQAccounts(e.target.checked)} data-testid="q-accounts-checkbox" />
              <span>I have at least <strong>7 open accounts</strong> on my credit report (credit cards, loans, lines of credit — bad or negative standing still counts, that is what we repair)</span>
            </label>
            <label className="check-opt">
              <input type="checkbox" checked={qLimits} onChange={(e) => setQLimits(e.target.checked)} data-testid="q-limits-checkbox" />
              <span>My total credit card limits add up to <strong>$10,000 or more</strong> (accounts in bad or negative standing still count toward the total)</span>
            </label>
          </div>
          <p className="qual-note">If you checked both boxes, you likely qualify. Submit your application and we will confirm during your call. If you are unsure, apply anyway — our team will walk you through it.</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);
